import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, empty, of } from 'rxjs';
import { AppConfig } from '../app.config';
import { tap, catchError } from 'rxjs/operators';
import { CustomHttpParamsEncoder } from './settings/CustomHttpParamsEncoder';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user: any;
  project: any;

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  public getUserInfo(): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token_info'));
    const userId = JSON.parse(localStorage.getItem('user_id'));
    const headers: HttpHeaders = new HttpHeaders()
      .append('Authorization', `${token['token_type']} ${token['access_token']}`);
    const params: HttpParams = new HttpParams()
      .append('app_scheme', 'SCHOOLS');
    return this.http.get(this.config.getEndpoint('member/my_info'), { headers, params }).pipe(
      tap(user => {
        this.user = { ...user };
        console.log(this.user);
      })
    );
  }

  getUserProjects(userId: string): Observable<any> {
    let params = new HttpParams({ encoder: new CustomHttpParamsEncoder() }).set('user_id', userId);

    return this.http.get(this.config.getEndpoint('member/user_projects'), { params });
  }

  loginToProject(projectId: number): Observable<any> {
    let params = new HttpParams().set('project_id', projectId.toString());

    return this.http.post(this.config.getEndpoint('member/project_login'), null, { params: params }).pipe(
      tap(project => {
        this.project = project;
        console.log(this.project);
      }),
      catchError((e: HttpErrorResponse) => {
        localStorage.removeItem('project_id');
        return empty();
      })
    );
  }

  saveUserInfo(user): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    const params = new HttpParams()
      .append('geocode_address', 'true')
      .append('project_id', project.projectID.id)
      .append('attributes', 'firstName,address,gender,language,userType,sendToInboxFromPhone,birthYear');
    return this.http.post(`/api2/member/user_update`, this.toDbo(user), { params });
  }

  private toDbo(user) {
    const userId = JSON.parse(localStorage.getItem('user_id'));
    const resToDbo = {
      attributes: {
        firstName: [user.name.trim()],
        address: [
          {
            street: user.address.street.name.trim(),
            houseNumber: user.address.houseNumber.trim(),
            boxNumber: "",
            postalCode: user.address.postalCode.trim(),
            country: user.address.country.trim(),
            municipality: user.address.municipality.trim()
          }
        ],
        gender: [user.gender],
        language: [user.language],
        userType: [user.userType],
        sendToInboxFromPhone: [user.sendToInboxFromPhone],
        birthYear: user.birthYear && [parseInt(user.birthYear)] || null
      },
      userId: {
        '@class': '.UserID',
        id: userId
      }
    }
    return resToDbo;
  }

  getZeusStatus(): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token_info'));
    const headers: HttpHeaders = new HttpHeaders()
      .append('Authorization', `${token['token_type']} ${token['access_token']}`);
    return this.http.post(`/api2/member/my_zeus_status`, {}, { headers });
  }

}
